import { useState } from "react";
import Button from "../button/Button.tsx";
import axiosInstance from "../../utils/axios-instance.ts";
import { toast } from "react-toastify";
import { ParseErrors } from "../../utils/parse-errors.ts";
import { useNavigate } from "react-router-dom";
import UseAuth from "../../utils/use-auth.ts";

const PricingCard = ({
  title,
  subtitle,
  features,
  type,
  isActive,
  ind,
  isMonthly,
  euroPrice,
}) => {
  const { user } = UseAuth();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const HandleSubscription = async () => {
    setLoading(true);
    try {
      const res = await axiosInstance.post(
        "/payment/stripe/create-subscription",
        { type, plan: isMonthly ? "monthly" : "yearly" }
      );
      window.location = res.data.session.url;
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(ParseErrors(error));
      console.log(error);
    }
  };

  const isPopular = title === "Professional";

  return (
    <div className="group w-full">
      {isPopular && (
        <div className="bg-blue w-full py-2.5 rounded-tr-2xl rounded-tl-2xl text-center text-sm tracking-wide text-white font-medium uppercase">
          <h2>Most Popular</h2>
        </div>
      )}
      <div
        className={`w-full mx-auto border rounded-2xl shadow-soft hover:shadow-card transition-all duration-300 p-8 lg:p-10 cursor-pointer ${
          isActive
            ? "bg-blue text-white border-blue"
            : "bg-white text-lightBlack border-gray-200 hover:border-blue"
        } ${isPopular ? "rounded-tl-none rounded-tr-none -mt-px" : ""}`}
      >
        <div className="text-center">
          <div
            className={`font-medium tracking-tight inline-flex items-center justify-center px-5 py-2 rounded-full mb-5 text-sm uppercase ${
              isActive
                ? "bg-white/15 text-white"
                : "bg-gray-50 text-blue"
            }`}
          >
            {title}
          </div>
          <div
            className={`text-3xl lg:text-4xl font-semibold tracking-tight font-display ${
              isActive ? "text-white" : "text-lightBlack"
            }`}
          >
            {title !== "Enterprise"
              ? `$${isMonthly ? subtitle : Math.floor((subtitle * 75) / 100)}`
              : subtitle}{" "}
            {title !== "Enterprise" && (
              <span className={`text-sm mx-1 font-normal ${isActive ? "text-white/70" : "text-gray-400"}`}>or</span>
            )}
            {title !== "Enterprise"
              ? `€${isMonthly ? euroPrice : Math.floor((euroPrice * 75) / 100)}`
              : euroPrice}
          </div>
          <div className={`text-sm mt-1 mb-6 ${isActive ? "text-white/70" : "text-gray-500"}`}>User / Month</div>

          <div className={`h-px w-full mb-6 ${isActive ? "bg-white/15" : "bg-gray-100"}`}></div>

          <ul className="mb-8 space-y-3">
            {features.map((feature, index) => (
              <li
                key={index}
                className="flex items-start justify-start"
              >
                <svg
                  className={`min-w-4 min-h-4 md:w-5 md:h-5 mr-3 mt-[2px] ${
                    (isActive || index > 3) && ind === 0
                      ? isActive ? "text-white/40" : "text-gray-300"
                      : isActive ? "text-white" : "text-blue"
                  }`}
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2.2"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
                <span
                  className={`text-[14.5px] leading-relaxed text-start capitalize ${
                    (isActive || index > 3) && ind === 0
                      ? isActive ? "text-white/50" : "text-gray-400"
                      : ""
                  }`}
                >
                  {feature}
                </span>
              </li>
            ))}
          </ul>
          {user?.subscription?.type === type &&
          user?.subscription?.plan === (isMonthly ? "monthly" : "yearly") ? (
            <Button className="!bg-gray-100 !text-gray-500 !border-gray-100" disabled>
              Current Plan
            </Button>
          ) : (
            <Button
              children={title === "Enterprise" ? "Contact Us" : "Choose Plan"}
              isLoading={loading}
              disabled={loading}
              className={isActive ? "!bg-white !text-blue" : ""}
              onClick={
                title === "Enterprise"
                  ? () => navigate("/contact")
                  : user?.id
                  ? HandleSubscription
                  : () => navigate("/login")
              }
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default PricingCard;
